<div class="container-contract" id="begin">
  <div class="center-items contract-title">
    Selecciona un tipo de contrato
  </div>
  <div class="field-rows">
    <div class="field-container">
      <div class="main-field">
        <div class="field-left" (click)="this.calculateAmountToPay('contract')"
          [ngClass]="{'field-on': this.contract==true , 'field-off': this.contract==false}">
          <div>
            <div class="field-title" *ngIf="this.data.contracts.length > 0 ">
              Con Contrato
            </div>
            <div [ngClass]="{'description-on': this.contract==true , 'description-off': this.contract==false}">
              <label *ngFor="let item of this.data.contracts; let i = index">
                {{item.contractInMoths}}
                <span *ngIf="this.data.contracts.length > 1  && i ==0">
                  y&nbsp;
                </span>
              </label>
              meses de Contrato
            </div>
          </div>
        </div>
      </div>
      <div class="main-field">
        <div class="field-right" (click)="this.calculateAmountToPay('withoutContract')"
          [ngClass]="{'field-on': this.contract==false , 'field-off': this.contract==true}">
          <div>
            <div class="field-title">
              Sin Contrato
            </div>
            <div class="description"
              [ngClass]="{'description-on': this.contract==false , 'description-off': this.contract==true}">
              <span>Sin verificación de Crédito</span>
              <br>
              <span>1 Mes de Plan por Adelantado</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="this.contract==true" class="cards-container">
      <div *ngFor="let item of this.data.contracts; let i = index"
        (click)="this.calculateAmountToPay(item.contractInMoths,i)"
        [ngClass]="{'card-on': this.contractSelect[i]==true , 'card-off': this.contractSelect[i]==false}">
        <div class="card-check">
          <div class="check-style">
            <div *ngIf="this.contractSelect[i]==true" class="circle"></div>
          </div>
        </div>
        <div class="card-info">
          <div class="f-w">
            {{item.contractInMoths}} Meses de Contrato
          </div>
          <div class="f-black">
            Llévate
            <span class="f-w" *ngIf="(item.regularPrice-(item.regularPrice * (item.firtsProductDiscount/100)))==0">
              Gratis </span>
            <span *ngIf="(item.regularPrice-(item.regularPrice * (item.firtsProductDiscount/100))) > 0">
              por
              <label class="f-w">
                {{ (item.regularPrice-(item.regularPrice * (item.firtsProductDiscount/100))) | currency }}
              </label>
            </span>
            el Primer Dispositivo.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <div class="grid-header-title">
    <div class="grid-info">
      <div>
        <img class="img-log" src="assets/images/mini-tv-logo.png">
      </div>
      <div>
        <span>Tu Dispositivo</span>
        <span class="p-r p-l">|</span>
        <span>{{this.quantity}} Dispositivo</span>
        <span class="p-r p-l">|</span>
        <span>{{this.typeOfContract}}</span>
      </div>
    </div>
    <div class="txt-right pay-info f-w">
      <div *ngIf="this.priceMonth > 0 && (this.contract==true && this.regularPriceCheck==false)">
        <label class="subtitle-pay-info"> Renta mensual:</label> {{this.priceMonth | currency}}
      </div>
    </div>
    <div class="txt-right pay-info f-w">
      <div *ngIf="this.amountPayable > 0 && (this.contract==false || this.regularPriceCheck==true)">
        <label class="subtitle-pay-info">Total a pagar hoy : </label> {{this.amountPayable | currency}}
      </div>
    </div>
    <div>
    </div>
  </div>
  <div>
    <div *ngIf="this.loadStreaming==true" class="striming-device-container">
      <div class="grid-rows">
        <div class="grid-rows b-b-gray p-b-40">
          <div class="grid-columns-c1">
            <div class="center-items">
              <img class="img-str" src="../../../../assets/images/iptv_caja_2.png" alt="">
            </div>
            <div class="grid-rows gap-40">
              <div class="grid-rows">
                <div class="f-big less-f p-botom">
                  Escoge tu Dispositivo
                </div>
                <div class="grid-c-d f-w-b">
                  <div>
                    Cantidad de dispositivos: 
                  </div>
                  <div>
                    <app-quantity-device (quantityAccessories)="this.updateQuantity($event)"
                      [msjMaxItems]="'El número máximo de dispositivos por persona es de 4'"
                      [numberAccessories]="this.quantity" [numMaxItems]="this.quantitiesAvailable">
                    </app-quantity-device>
                  </div>
                </div>
                <div class="l-h-2">
                  <div class="roboto-m ">
                    Términos y condiciones
                  </div>
                  <div class="check-terms">
                    <mat-checkbox [(ngModel)]="this.checkTerms" [color]="'warn'">
                    </mat-checkbox>
                    <div (click)="this.pupOpTermns()" class="servicetermslink">Aceptar términos y
                      condiciones.
                    </div>
                  </div>
                </div>
                <div class="info-streaming">
                  *Utiliza un dispositivo de streaming compatible. Puede descargar la aplicación en su
                  <br>
                  dispositivo compatible para empezar a transmitir TV+
                </div>
                <div class="grid-rows">
                  <div class="f-big less-f f-w-b">
                    Selecciona una forma de pago
                  </div>
                  <div class="grid-columns-2">
                    <div class="grid-rows" *ngIf="this.amountPayable > 0 && this.contract==true">
                      <div class="payment-box p-b-20" (click)="this.selectPaymentMethods(this.regularPriceCheck)"
                        [ngClass]="{'on': !regularPriceCheck,'off': regularPriceCheck}">
                        <div>
                          COMPRAR A PLAZOS
                        </div>
                        <div class="payment-font"
                          [ngClass]="{'f-white': !regularPriceCheck,'f-red': regularPriceCheck}">
                          {{priceMonth | currency}} Mes
                        </div>
                        <div>
                          Paga en {{month}} meses
                        </div>
                      </div>
                      <div class="grid-months" *ngIf="this.viewMonths==true">
                        <div *ngFor="let prices of this.prices; let i= index" (click)="this.selectMonths(i);"
                          class="term-option-box"
                          [ngClass]="{'on2': prices.defaultPrice==true,'off2': !prices.defaultPrice,'hidden': prices.view==false }">
                          <span>{{prices.intMonths}} Meses </span>

                        </div>
                      </div>
                    </div>
                    <div class="grid-2-r">
                      <div class="payment-box-2" (click)="this.selectPaymentMethods(this.regularPriceCheck)"
                        [ngClass]="
                                                        {'on': (this.regularPriceCheck==true && this.amountPayable > 0),
                                                        'off': (this.regularPriceCheck==false && this.amountPayable > 0),
                                                        'on-free': (this.regularPriceCheck==true && this.amountPayable == 0),
                                                        'off-free': (this.regularPriceCheck==false && this.amountPayable == 0)}">
                        <div>
                          PRECIO REGULAR
                        </div>
                        <div class="payment-font"
                          [ngClass]="{'f-white': this.regularPriceCheck,'f-red': !this.regularPriceCheck}">
                          {{this.amountPayable | currency}} Mes
                          <div *ngIf="this.amountPayable == 0">
                            Primer dispositivo Gratis
                          </div>
                          <div *ngIf="this.amountPayable != 0">
                            Monto a pagar hoy
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box-info">
                    <div *ngIf="this.quantity==1" class="box-info-text">
                      PRIMER DISPOSITIVO <span class="blue-txt"> GRATIS</span>
                    </div>
                    <div *ngIf="this.quantity>1 " class="box-info-text">
                      COSTO ADICIONAL POR DISPOSITIVO {{ this.regularPrice |currency }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="basicrow box">
          <div class="addservicescontinuebtn-2 vcenter column-2" (click)="continueToPay(this.checkTerms);">
            <span class="tabcell">
              CONTINUAR
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
